/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// material
import Status from 'material/embeds/status/status';
import ContentIndicator from 'material/embeds/contentindicator/contentindicator';
import ToolTip from 'material/message/tooltip/tooltip';
// import Loader from 'material/loader/loader';
import Link from 'material/ctas/link/link_container';
import Button from 'material/ctas/button/button_container';
import DeleteMessage from 'material/message/popup/delete/delete';
import Icon from 'material/graphic/icon/icon';
// utils
import { url } from 'utils/urls';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/embedcard/embedcard_styles';



/* ========== ~~~~~~~~~~ EMBED CARD : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class EmbedCard extends Component {
    constructor(props) {
        super(props);
        this.state = {
            editEmbedClicked: false,
            embedAnalyticsClicked: false,
            deleteEmbedClicked: false
        }
    }
    componentDidUpdate(prevProps) {
        // reset state if delete embed call fails
        if ( this.state.deleteEmbedClicked && prevProps.disableEmbedCards && !this.props.disableEmbedCards) {
            this.setState({ deleteEmbedClicked: false })
        }
    }
    handleEditEmbedClicked = () => {
        this.setState({ editEmbedClicked: true });
        this.props.editEmbed(this.props.embedUUID)
    };
    handleViewAnalyticsClicked = () => {
        this.setState({ embedAnalyticsClicked: true });
        this.props.viewAnalytics(this.props.embedUUID)

    };
    handleDeleteEmbedClicked = () => {
        this.setState({ deleteEmbedClicked: true });
        this.props.deleteEmbed(this.props.embedUUID);
    };
    handleEmbedImageClicked = () => this.props.editPermitted ? this.handleEditEmbedClicked() : this.handleViewAnalyticsClicked();
    _renderEditEmbedLink = () => {
        return <ToolTip position={`top`} action={`mouseenter`} content={`Edit Embed`}>
                    <Link type={`action`}
                            text={``}
                            color={`neutral`}
                            action={this.handleEditEmbedClicked}
                            name={`edit`}
                            disabled={this.state.embedAnalyticsClicked || this.state.deleteEmbedClicked}
                            operation={`load`}
                            processing={this.state.editEmbedClicked}
                            icon={<Icon name={`pen`} />}
                            iconOnly
                     />
                </ToolTip>
    };
    _renderViewAnalyticsButton = () => {
        return <ToolTip position={`top`} action={`mouseenter`} content={`View Analytics`}>
                    <Link type={`action`}
                           text={``}
                           color={`neutral`}
                           action={this.handleViewAnalyticsClicked}
                           disabled={this.state.editEmbedClicked || this.state.deleteEmbedClicked}
                           operation={`load`}
                           processing={this.state.embedAnalyticsClicked}
                           name={`viewanalytics`}
                           icon={<Icon name={`chart-line`} />}
                           iconOnly
                        />
            </ToolTip>
    };
    _renderDeleteEmbedButton = () => {
        if(!this.props.mocked) return null;
        return <ToolTip position={`top`} action={`mouseenter`} content={`Delete Embed`}>
                    <Link  type={`modal`}
                           text={``}
                           color={`neutral`}
                           action={<DeleteMessage itemType={'embed'} itemName={this.props.name} primaryAction={this.handleDeleteEmbedClicked} />}
                           disabled={this.state.editEmbedClicked || this.state.embedAnalyticsClicked}
                           operation={`delete`}
                           processing={this.state.deleteEmbedClicked}
                           name={`deleteembed`}
                           icon={<Icon name={`trash-alt`} />}
                           iconOnly
                        />
            </ToolTip>
    };
    showText = () => this.props.status ? 'online' : 'offline';
    render() {
        const status = this.props.status;
        const name = this.props.name;
        const site = this.props.site;
        const posterImage = this.props.posterImage ? this.props.posterImage : `${url.image.app}/logo-insticator-icon.svg`;
        const hasImage = !!this.props.posterImage;
        const embedClicked = this.props.disableEmbedCards && !this.state.editEmbedClicked && !this.state.embedAnalyticsClicked;
        const clickedState = this.state.editEmbedClicked || this.state.embedAnalyticsClicked || this.state.deleteEmbedClicked;
        return(
            <div className={`embedcard ${this.props.classes.embedcard} disabled-${embedClicked} ${status} hasImage-${hasImage}`}>
                <div className={`cover disabled-${clickedState}`} style={{backgroundImage:`url(${posterImage})`}} onClick={this.handleEmbedImageClicked}>
                    <div className={`overlay`} />
                </div>
                <div className={`details`}>
                    <ToolTip position={`top`} action={`mouseenter`} content={name}>
                        <div className={`name`} >{name}</div>
                    </ToolTip>
                    <ToolTip position={`top`} action={`mouseenter`} content={site}>
                        <div className={`site`} >{site}</div>
                    </ToolTip>
                </div>
                <div className={`info`}>
                    <label>Contains:</label>
                    {!this.props.activeContents.length ? <span className='nocontent'>No Content</span> :
                        <ContentIndicator type={`indicator`} processClick={null} activeContents={this.props.activeContents} disabled={false} />
                    }
                </div>
                <div className={`actions`}>
                    <div className={`controls loading`}>
                        {this.props.editPermitted ? this._renderEditEmbedLink() : null}
                        {this._renderViewAnalyticsButton()}
                        {this._renderDeleteEmbedButton()}
                    </div>
                    <div className={`status`}>
                        <Status live={status} variant={`dot`} type={`indicator`} /> <span className={`text`}>{this.showText()}</span>
                    </div>
                </div>
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(EmbedCard);
